module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-03-439f93922a23a3a25e48500641e9dd05.jpg";